import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authUtil from '../util/auth';

/*
      props.access = {
         type (required): string,  (role/privilege)
         value: (required),
      }

      IF props.access.type === role
         value = {
            employer: string[],
            partner: string[]
         }

      ELSE IF props.access.type === privilege
         value = string
 */

const InnerAccessControl = (props) => {
   const [hasAccess, setHasAccess] = useState(false);
   useEffect(() => {
      const {
         userRoleListEmployer,
         userRoleListPartner,
         userEmployerPrivileges,
         isLoggedInPartner,
         isLoggedInEmployer,
         access,
      } = props;
      setHasAccess(
         authUtil.hasAuthAccessBase({
            userRoleListEmployer,
            userRoleListPartner,
            userEmployerPrivileges,
            isLoggedInPartner,
            isLoggedInEmployer,
            access,
         }),
      );
   }, [
      JSON.stringify({
         userRoleListEmployer: props.userRoleListEmployer,
         userRoleListPartner: props.userRoleListPartner,
         userEmployerPrivileges: props.userEmployerPrivileges,
         isLoggedInPartner: props.isLoggedInPartner,
         isLoggedInEmployer: props.isLoggedInEmployer,
         access: props.access,
      }),
   ]);

   return (hasAccess ? props.children : props.renderNoAccess);
};


const mapStateToProps = (store) => ({
   isLoggedInEmployer: !!(store.authReducer?.isLoggedIn),
   isLoggedInPartner: !!(store.authReducer?.isLoggedInPartner),
   userRoleListEmployer: store?.authReducer?.loggedInUser?.roles || [],
   userRoleListPartner: store?.authReducer?.loggedInUserPartner?.roles || [],
   userEmployerPrivileges: store?.privilegeReducer?.privileges || null,
});

const AccessControl = connect(mapStateToProps)(InnerAccessControl);

AccessControl.propTypes = {
   access: PropTypes.shape({
      type: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.shape({
            employer: PropTypes.arrayOf(PropTypes.string),
            partner: PropTypes.arrayOf(PropTypes.string),
         }),
      ]).isRequired,
   }).isRequired,
   children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
   ]).isRequired,
   renderNoAccess: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
   ]),
};

AccessControl.defaultProps = {
   access: undefined,
   renderNoAccess: null,
};

export default AccessControl;
